import Intro from "../../../../src/components/v8-jit/intro";
import * as React from 'react';
export default {
  Intro,
  React
};